import React, { useState } from "react";
import { ehrAdviceInput, ehrDiagnosisInput } from "../Utils/EHRInputs";
import { Button } from "@mui/material";
import useSnackbar from "../../../../../hooks/digitalMarketing/useSnackbar";
import {
  useAddEHRDiagnosisMutation,
  useGetAllBranchesQuery,
  useUpdateEHRDiagnosisMutation,
} from "../../../../../Service/Masters";
import Toast from "../../../../../Component/DigitalMarketing/Toast";
import { useSelector } from "react-redux";
import BackdropLoader from "../../../../../Component/DigitalMarketing/BackDropLoader";

const DiagnosisDetails = (props) => {
  const { updateData, refetchDiagnosis, setShow } = props;
  const [formData, setFormData] = useState({
    diagnosis: updateData.diagnosis || "",
    branchId: updateData.branchId || "",
  });
  const account = useSelector((state: any) => state.auth);
  const { roleName } = account;
  const [addDiagnosis,{isLoading : addLoading}] = useAddEHRDiagnosisMutation();
  const [updateDiagnosis,{isLoading : updateLoading}] = useUpdateEHRDiagnosisMutation();
  const { open, message, openSnackBar, type } = useSnackbar();
  const [submit, setSubmit] = useState(false);
  const { data } = useGetAllBranchesQuery<any>({
    refetchOnMountOrArgChange: true,
  });
  const handleChangeInfo = (e: any) => {
    let { name, value } = e.target;
     value = value.replace(/^[\s]+|[^a-zA-Z0-9 ]/g, '');
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async () => {
    setSubmit(true);
    const requiredFields = ["diagnosis"];
    const isBranchUser = roleName === "branch";
    
    if (!isBranchUser) {
      requiredFields.push("branchId");
    }
    
    const missingFields = Object.entries(formData).filter(
      ([key, value]) => requiredFields.includes(key) && !value
    );
    
    if (missingFields.length > 0) {
      openSnackBar("Fill required data", "error");
      return;
    }
    if (updateData?.id) {
      try {
        await updateDiagnosis({
          id: updateData.id,
          ...formData,
        }).unwrap();
        refetchDiagnosis();
        openSnackBar("Updated successfully");
        setTimeout(() => {
          setShow(false);
        }, 350);
      } catch (error: any) {
        if (error?.status === 400) {
          openSnackBar(error?.data?.error, "error");
        }
      }
    } else {
      try {
        await addDiagnosis({ ...formData, activeStatus: "1" }).unwrap();
        refetchDiagnosis();
        openSnackBar("Created Successfully");
        setTimeout(() => {
          setShow(false);
        }, 350);
      } catch (error: any) {
        if (error?.status === 400) {
          openSnackBar(error?.data?.error, "error");
        }
      }
    }
  };

  return (
    <div>
      <BackdropLoader loader={addLoading || updateLoading}/>
      <Toast open={open} type={type} message={message} />
      <div className="mt-3">
        <span className="f-18 fw-700">
          {updateData.id ? "Edit Diagnosis" : "Add Diagnosis"}
        </span>
      </div>
      {ehrDiagnosisInput.map((a, i) => (
        <div className="input-custom mt-2" key={i}>
          <a.tag
            img={a.img}
            label={a.label}
            name={a.name}
            value={formData[a.key]}
            handleChange={handleChangeInfo}
            validation={a.validation}
            keyName={a.key}
            submit={submit}
          />
        </div>
      ))}
      {roleName !== "branch" && (
        <div className="d-flex justify-content-between">
          <div>
            <span className="det-label">Branch</span>
          </div>
          <div>
            <select
              onChange={(event) => handleChangeInfo(event)}
              className="input-custom"
              placeholder="Select Branch"
              name="branchId"
              value={formData.branchId}
            >
              <option value="">Select Branch</option>
              {data?.data?.map((branch) => (
                <option key={branch.id} value={branch.id}>
                  {branch.branchName}
                </option>
              ))}
            </select>
          </div>
        </div>
      )}
      <div
        className="d-flex justify-content-center mt-4"
        onClick={handleSubmit}
      >
        <Button variant="contained" id="btn-save">
          {updateData.id ? "Update Diagnosis" : "Add Diagnosis"}
        </Button>
      </div>
    </div>
  );
};

export default DiagnosisDetails;
